import CheckoutFailed from './CheckoutFailed'
import CheckoutProcessing from './CheckoutProcessing'
import CheckoutSuccess from './CheckoutSuccess'
import { PAYMENT_FAILED, PAYMENT_SUCCEEDED } from './constants'

export default function CheckoutFinalStep({ checkoutLastStepData, isWidget }) {
  const { paymentStatus } = checkoutLastStepData

  if(paymentStatus === PAYMENT_SUCCEEDED) {
    return <CheckoutSuccess {...checkoutLastStepData} isWidget={isWidget} />
  } else if(paymentStatus === PAYMENT_FAILED) {
    return <CheckoutFailed />
  }

  return <CheckoutProcessing />
}
